import {
  tableColumnsWidth,
  key,
  slot,
  renderFn
} from '@/assets/js/resetTableStyle';

export const columns = [
  key(null, null, tableColumnsWidth.type1, {
    type: 'selection',
    fixed: 'left'
  }),
  {
    title: '套餐ID',
    key: 'productPackageId',
    width: tableColumnsWidth.type4,
    fixed: 'left'
  },
  {
    title: '课程套餐名称',
    slot: 'packageName',
    width: tableColumnsWidth.type6,
    fixed: 'left'
  },

  {
    title: '学校名称',
    slot: 'schoolName',
    width: tableColumnsWidth.type6
  },
  {
    title: '套餐价格(元)',
    key: 'classroomFee',
    width: 100,
    render: (h, params) => {
      return h('div', [abs(params.row.classroomFee)]);
    },
    align: 'center'
  },
  {
    title: '套餐内容',
    width: 130,
    key: 'courseTypeKindList',
    render: (h, params) => {
      return h('div', [courseFilterTypeKind(params.row.courseTypeKindList)]);
    }
  },
  {
    title: '学期',
    key: 'termName',
    width: tableColumnsWidth.type4
  },
  {
    title: '校区名称',
    key: 'branchName',
    width: tableColumnsWidth.type6
  },
  {
    title: '提供方',
    slot: 'providerName',
    width: tableColumnsWidth.type6
  },
  {
    title: '已报名人数',
    key: 'registeredNumbers',
    width: 80,
    align: 'center'
  },
  {
    title: '限定报名年级',
    key: 'isLimitEnrollStr',
    width: 130,
    align: 'center'
  },
  {
    title: '套餐商品状态',
    key: 'courseEnrollState',
    width: tableColumnsWidth.type2,
    render: (h, params) => {
      return h('div', [courseEnrollState[params.row.courseEnrollState]]);
    },
    align: 'center'
  },
  {
    title: '上架状态',
    width: tableColumnsWidth.type2,
    slot: 'classroomState',
    align: 'center'
  },
  {
    title: '报名截止时间',
    key: 'enrollTimeEnd',
    width: 180
  },
  {
    title: '创建时间',
    key: 'createTime',
    width: 180
  },
  {
    title: '报名开始时间',
    key: 'enrollTimeBegin',
    width: 180
  },
  {
    title: '报名结束时间',
    key: 'enrollTimeEnd',
    width: 180
  },
  {
    title: '退费截止时间',
    key: 'refundDeadLine',
    width: 180
  },
  {
    title: '上架时间',
    slot: 'sortTime',
    width: 230,
    renderHeader: (h, params) => {
      return h(
        'Tooltip',
        { props: { placement: 'top', transfer: true, 'max-width': '300' }}, // 提示组件的属性
        [
          h('span', [
            h('span', '上架时间'), // 列名
            h('Icon', { props: { type: 'ios-alert-outline' }}) // 问号图标
          ]),
          h(
            'span',
            {
              slot: 'content'
            },
            '上架时间越靠前，套餐在家长端显示越靠前'
          ) // 提示内容
        ]
      );
    }
  },

  {
    title: '操作',
    slot: 'action',
    fixed: 'right',
    width: 150
  }
];

export function courseFilterTypeKind(list) {
  const result = [];
  const arr = new Set(list)
  ;[...arr].forEach((item) => {
    result.push(courseType[item]);
  });
  return result.join('、');
}

const classroomState = {
  0: '已下架',
  4: '已上架'
};
const courseEnrollState = {
  1: '报名中',
  2: '已报名',
  3: '已截止',
  4: '已下架',
  6: '未开始'
};

export const nameList = [
  { label: '套餐名称', value: 'comboName' },
  { label: '套餐ID', value: 'comboId' }
];

export const courseEnrollStateList = [
  { label: '全部状态', value: -1 },
  { label: '报名中', value: 1 },
  { label: '已报满', value: 2 },
  { label: '已截止', value: 3 },
  { label: '已下架', value: 4 },
  { label: '未开始', value: 6 }
];

export const classroomStateList = [
  { label: '全部上架状态', value: -1 },
  { label: '已上架', value: 4 },
  { label: '已下架', value: 0 }
];

export const selectComcolumns = [
  {
    title: '课程商品ID',
    key: 'productId',
    width: tableColumnsWidth.type4,
    align: 'center'
  },
  {
    title: '课程商品名称',
    key: 'productName',
    width: tableColumnsWidth.type6,
    align: 'center'
  },
  {
    title: '课程商品类型',
    key: 'classType',
    width: 100,
    align: 'center',
    render: (h, params) => {
      return h('div', [
        params.row.classType ? classType[params.row.classType] : ''
      ]);
    }
  },
  {
    title: '价格（元）',
    key: 'classroomFee',
    width: 110,
    align: 'center',
    render: (h, params) => {
      return h('div', [
        params.row.classroomFee ? Number(params.row.classroomFee) / 100 : ''
      ]);
    }
  },
  {
    title: '可报人数',
    width: 100,
    align: 'center',
    slot: 'studentTotal'
  },
  {
    title: '报名范围',
    width: 130,
    align: 'center',
    key: 'isLimitEnrollStr'
  },
  {
    title: '列表可见',
    slot: 'visibleType',
    width: 130
  },
  {
    title: '课时',
    width: 80,
    align: 'center',
    key: 'classroomTotal'
  },
  {
    title: '预计上课时间',
    slot: 'timeDesc',
    align: 'center',
    width: 200
  },
  // {
  //   title: '课程ID',
  //   key: 'courseId',
  //   width: tableColumnsWidth.type4
  // },
  // {
  //   title: '课程名称',
  //   key: 'courseName',
  //   width: 160
  // },

  {
    title: '提供方',
    key: 'providerName',
    align: 'center',
    minWidth: 180
  },
  {
    title: '排序',
    key: 'sort',
    align: 'center',
    width: 100
  },
  {
    title: '必选项目',
    slot: 'comboType',
    align: 'center',
    width: 100,
    renderHeader: (h, params) => {
      return h(
        'Tooltip',
        { props: { placement: 'top', transfer: true, 'max-width': '300' }}, // 提示组件的属性
        [
          h('span', [
            h('span', '必选项目'), // 列名
            h('Icon', { props: { type: 'ios-alert-outline' }}) // 问号图标
          ]),
          h(
            'span',
            {
              slot: 'content'
            },
            '勾选后用户下单组合课程时必须报名该课程'
          ) // 提示内容
        ]
      );
    }
  },
  {
    title: '操作',
    slot: 'action',
    width: 100,
    align: 'center'
  }
];

export const courseType = {
  11: '艺术',
  12: '科技',
  13: '体育',
  14: '美术',
  15: '综合实践',
  21: '早托',
  22: '午托',
  23: '晚托',
  24: '全托'
};

export const classType = {
  1: '素质课',
  2: '基础托管'
};

export function abs(val) {
  const str = (val / 100).toFixed(2) + '';
  const intSum = str
    .substring(0, str.indexOf('.'))
    .replace(/\B(?=(?:\d{3})+$)/g, ','); // 取到整数部分
  const dot = str.substring(str.length, str.indexOf('.')); // 取到小数部分搜索
  const ret = intSum + dot;
  return ret;
}
